// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .alert-container {
  position: fixed;
  bottom: 20px;
  right: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 1000;
}

.alert-box {
  min-width: 280px;
  padding: 16px;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  gap: 12px;
  animation: slideIn 0.3s ease-out forwards;
  border-left: 6px solid #ccc;
}

.alert-box.success { border-color: #10b981; color: #064e3b; }
.alert-box.error { border-color: #ef4444; color: #7f1d1d; }

@keyframes slideIn {
  from { transform: translateX(100%); opacity: 0; }
  to { transform: translateX(0); opacity: 1; }
} */
.alert-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  z-index: 9999;
}

.alert-box {
  width: 100%;
  padding: 18px 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  /* Smooth "pop" animation */
  animation: slideInFromTop 0.5s cubic-bezier(0.19, 1, 0.22, 1) forwards;
}

/* --- The Beautiful Warning Style --- */
.alert-box.warning {
  background-color: #fffbeb; /* Very soft cream/amber */
  color: #92400e;            /* Deep amber text for readability */
  border-bottom: 3px solid #fbbf24; /* Golden-yellow accent */
  /* Soft glow effect */
  box-shadow: 0 4px 20px rgba(251, 191, 36, 0.15); 
}

/* Styling the Text */
.alert-box p {
  margin: 0;
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
  font-weight: 500;
  font-size: 0.95rem;
  letter-spacing: -0.01em;
}

/* Styling the Icon */
.alert-box .icon {
  margin-right: 12px;
  font-size: 1.2rem;
  /* Optional: Add a pulse animation to the warning icon */
  animation: pulse 2s infinite;
}

/* Animations */
@keyframes slideInFromTop {
  from { transform: translateY(-100%); }
  to { transform: translateY(0); }
}

@keyframes pulse {
  0% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.1); opacity: 0.8; }
  100% { transform: scale(1); opacity: 1; }
}

/* --- Success: Fresh and Clean --- */
.alert-box.success {
  background-color: rgba(236, 253, 245, 0.9); /* Soft Emerald */
  color: #065f46;                             /* Deep Emerald text */
  border-bottom: 3px solid #10b981;
  box-shadow: 0 4px 20px rgba(16, 185, 129, 0.15);
  backdrop-filter: blur(10px);               /* Glass effect */
}

/* --- Error: Sophisticated Red (not aggressive) --- */
.alert-box.error {
  background-color: rgba(254, 242, 242, 0.9); /* Soft Rose */
  color: #991b1b;                             /* Deep Crimson text */
  border-bottom: 3px solid #ef4444;
  box-shadow: 0 4px 20px rgba(239, 68, 68, 0.15);
  backdrop-filter: blur(10px);
}

/* --- Info: Calm and Trustworthy --- */
.alert-box.info {
  background-color: rgba(239, 246, 255, 0.9); /* Soft Sky Blue */
  color: #1e40af;                             /* Deep Blue text */
  border-bottom: 3px solid #3b82f6;
  box-shadow: 0 4px 20px rgba(59, 130, 246, 0.15);
  backdrop-filter: blur(10px);
}

/* --- Universal Icon Refinement --- */
.alert-box .icon {
  margin-right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* Applying the pulse to all, or you can keep it just for warning */
  animation: pulse 2.5s infinite ease-in-out;
}

/* Added a slight hover effect just in case the user interacts with it */
.alert-box:hover {
  filter: brightness(0.98);
  cursor: default;
}`, "",{"version":3,"sources":["webpack://./src/components/Contexts/AlertContext.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA6BG;AACH;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,4CAA4C;EAC5C,yBAAyB;EACzB,2BAA2B;EAC3B,sEAAsE;AACxE;;AAEA,wCAAwC;AACxC;EACE,yBAAyB,EAAE,0BAA0B;EACrD,cAAc,aAAa,oCAAoC;EAC/D,gCAAgC,EAAE,yBAAyB;EAC3D,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA,qBAAqB;AACrB;EACE,SAAS;EACT,0DAA0D;EAC1D,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,wDAAwD;EACxD,4BAA4B;AAC9B;;AAEA,eAAe;AACf;EACE,OAAO,4BAA4B,EAAE;EACrC,KAAK,wBAAwB,EAAE;AACjC;;AAEA;EACE,KAAK,mBAAmB,EAAE,UAAU,EAAE;EACtC,MAAM,qBAAqB,EAAE,YAAY,EAAE;EAC3C,OAAO,mBAAmB,EAAE,UAAU,EAAE;AAC1C;;AAEA,qCAAqC;AACrC;EACE,0CAA0C,EAAE,iBAAiB;EAC7D,cAAc,8BAA8B,sBAAsB;EAClE,gCAAgC;EAChC,+CAA+C;EAC/C,2BAA2B,gBAAgB,iBAAiB;AAC9D;;AAEA,sDAAsD;AACtD;EACE,0CAA0C,EAAE,cAAc;EAC1D,cAAc,8BAA8B,sBAAsB;EAClE,gCAAgC;EAChC,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA,uCAAuC;AACvC;EACE,0CAA0C,EAAE,kBAAkB;EAC9D,cAAc,8BAA8B,mBAAmB;EAC/D,gCAAgC;EAChC,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mEAAmE;EACnE,0CAA0C;AAC5C;;AAEA,wEAAwE;AACxE;EACE,wBAAwB;EACxB,eAAe;AACjB","sourcesContent":["/* .alert-container {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  z-index: 1000;\n}\n\n.alert-box {\n  min-width: 280px;\n  padding: 16px;\n  border-radius: 12px;\n  background: #fff;\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  animation: slideIn 0.3s ease-out forwards;\n  border-left: 6px solid #ccc;\n}\n\n.alert-box.success { border-color: #10b981; color: #064e3b; }\n.alert-box.error { border-color: #ef4444; color: #7f1d1d; }\n\n@keyframes slideIn {\n  from { transform: translateX(100%); opacity: 0; }\n  to { transform: translateX(0); opacity: 1; }\n} */\n.alert-container {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  flex-direction: column;\n  z-index: 9999;\n}\n\n.alert-box {\n  width: 100%;\n  padding: 18px 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n  transition: all 0.3s ease;\n  /* Smooth \"pop\" animation */\n  animation: slideInFromTop 0.5s cubic-bezier(0.19, 1, 0.22, 1) forwards;\n}\n\n/* --- The Beautiful Warning Style --- */\n.alert-box.warning {\n  background-color: #fffbeb; /* Very soft cream/amber */\n  color: #92400e;            /* Deep amber text for readability */\n  border-bottom: 3px solid #fbbf24; /* Golden-yellow accent */\n  /* Soft glow effect */\n  box-shadow: 0 4px 20px rgba(251, 191, 36, 0.15); \n}\n\n/* Styling the Text */\n.alert-box p {\n  margin: 0;\n  font-family: 'Inter', system-ui, -apple-system, sans-serif;\n  font-weight: 500;\n  font-size: 0.95rem;\n  letter-spacing: -0.01em;\n}\n\n/* Styling the Icon */\n.alert-box .icon {\n  margin-right: 12px;\n  font-size: 1.2rem;\n  /* Optional: Add a pulse animation to the warning icon */\n  animation: pulse 2s infinite;\n}\n\n/* Animations */\n@keyframes slideInFromTop {\n  from { transform: translateY(-100%); }\n  to { transform: translateY(0); }\n}\n\n@keyframes pulse {\n  0% { transform: scale(1); opacity: 1; }\n  50% { transform: scale(1.1); opacity: 0.8; }\n  100% { transform: scale(1); opacity: 1; }\n}\n\n/* --- Success: Fresh and Clean --- */\n.alert-box.success {\n  background-color: rgba(236, 253, 245, 0.9); /* Soft Emerald */\n  color: #065f46;                             /* Deep Emerald text */\n  border-bottom: 3px solid #10b981;\n  box-shadow: 0 4px 20px rgba(16, 185, 129, 0.15);\n  backdrop-filter: blur(10px);               /* Glass effect */\n}\n\n/* --- Error: Sophisticated Red (not aggressive) --- */\n.alert-box.error {\n  background-color: rgba(254, 242, 242, 0.9); /* Soft Rose */\n  color: #991b1b;                             /* Deep Crimson text */\n  border-bottom: 3px solid #ef4444;\n  box-shadow: 0 4px 20px rgba(239, 68, 68, 0.15);\n  backdrop-filter: blur(10px);\n}\n\n/* --- Info: Calm and Trustworthy --- */\n.alert-box.info {\n  background-color: rgba(239, 246, 255, 0.9); /* Soft Sky Blue */\n  color: #1e40af;                             /* Deep Blue text */\n  border-bottom: 3px solid #3b82f6;\n  box-shadow: 0 4px 20px rgba(59, 130, 246, 0.15);\n  backdrop-filter: blur(10px);\n}\n\n/* --- Universal Icon Refinement --- */\n.alert-box .icon {\n  margin-right: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /* Applying the pulse to all, or you can keep it just for warning */\n  animation: pulse 2.5s infinite ease-in-out;\n}\n\n/* Added a slight hover effect just in case the user interacts with it */\n.alert-box:hover {\n  filter: brightness(0.98);\n  cursor: default;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
